// @ts-nocheck
import { CashtagWithIndices } from 'twitter-text';
import { hashtagStringLengthLimit } from '../plugins/HashtagPlugin';

// override cashtag regex
const cashtag = RegExp(`[A-Za-z0-9_]{1,${hashtagStringLengthLimit}}`, 'i');

// eslint-disable-next-line
const punct = /\!'#%&'\(\)*\+,\\\-\.\/:;<=>\?@\[\]\^_{|}~\$/;
// eslint-disable-next-line
const spacesGroup = /\x09-\x0D\x20\x85\xA0\u1680\u180E\u2000-\u200A\u2028\u2029\u202F\u205F\u3000/;

function regexSupplant(regex, map, flags) {
  flags = flags || '';

  if (typeof regex !== 'string') {
    if (regex.global && flags.indexOf('g') < 0) {
      flags += 'g';
    }

    if (regex.ignoreCase && flags.indexOf('i') < 0) {
      flags += 'i';
    }

    if (regex.multiline && flags.indexOf('m') < 0) {
      flags += 'm';
    }

    regex = regex.source;
  }

  return new RegExp(
    regex.replace(/#\{(\w+)\}/g, function (match, name) {
      let newRegex = map[name] || '';

      if (typeof newRegex !== 'string') {
        newRegex = newRegex.source;
      }

      return newRegex;
    }),
    flags,
  );
}

const spaces = regexSupplant(/[#{spacesGroup}]/, {
  spacesGroup: spacesGroup,
});

const validCashtag = regexSupplant(
  '(^|#{spaces})(\\$)(#{cashtag})(?=$|\\s|[#{punct}])',
  {
    cashtag: cashtag,
    spaces: spaces,
    punct: punct,
  },
  'gi',
);

// https://github.com/twitter/twitter-text/blob/master/js/src/extractCashtagsWithIndices.js
const extractCashtagsWithIndices = (text: string): CashtagWithIndices[] => {
  if (!text || text.indexOf('$') === -1) {
    return [];
  }

  const tags: CashtagWithIndices[] = [];

  text.replace(validCashtag, (match, before, dollar, cashtag, offset) => {
    const startPosition = offset + before.length;
    const endPosition = startPosition + cashtag.length + 1;
    tags.push({
      cashtag: cashtag,
      indices: [startPosition, endPosition],
    });
  });
  return tags;
};

export default {
  extractCashtagsWithIndices,
};
